"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validatePost;

var _jumpUtil = require("@hello10/jump-util");

var _pollAttrForType = _interopRequireDefault(require("./pollAttrForType"));

var _Enums = require("./Enums.json");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function validatePost(data) {
  var type = data.type;
  var is_piece = type === _Enums.PostType.Piece;
  var is_link = type === _Enums.PostType.Link;
  var is_poll = type === _Enums.PostType.Poll;
  var is_post = type === _Enums.PostType.Post;
  var is_image = type === _Enums.PostType.Image;

  if (is_poll) {
    var poll = data.poll;

    if (!(poll.type in _Enums.PollType)) {
      return false;
    }

    var attr = (0, _pollAttrForType["default"])(poll.type);
    var items = poll[attr]; // const is_url = (poll_type === PollType.Url);
    // const check = is_url ? isUrl : nonempty;

    return (0, _jumpUtil.nonempty)(items) && items.length >= 2 && items.every(_jumpUtil.nonempty);
  } else if (is_link) {
    return (0, _jumpUtil.nonempty)(data.url);
  } else if (is_piece) {
    return (0, _jumpUtil.nonempty)(data.piece_ids);
  } else if (is_image) {
    return (0, _jumpUtil.nonempty)(data.images);
  } else if (is_post) {
    return (0, _jumpUtil.nonempty)(data.text);
  } else {
    throw new Error("Invalid post type: ".concat(type));
  }
}